import { Injectable } from '@angular/core';
import { ApiService, DataService, LanguageService } from '../../../shared/services';
import { InspectionInfoPluginService } from '../../inspectionInfo/inspectionInfo-plugin.service';
import { InstallationInspectionInfoFactoryService } from './installation-inspection-info-plugin-factory.service';

@Injectable()
export class InstallationinspectionInfoPluginService extends InspectionInfoPluginService {
  subTypeKeys: any = [
    { value: 22, label: 'application.sub-type.PreInstallation' },
    { value: 23, label: 'application.sub-type.Installation' },
    { value: 24, label: 'application.sub-type.Instruction' }
  ];

  subTypes = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    inspectionInfoFactory: InstallationInspectionInfoFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, inspectionInfoFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe(() => this.applyTranslations());
  }

  getSubTypes() {
    return this.subTypes;
  }

  applyTranslations() {
    this.subTypes = [];
    this.copyTranslationValues(this.subTypeKeys, this.subTypes, this.language);
  }
}
